import { render, staticRenderFns } from "./factory_order_detail.vue?vue&type=template&id=5dcf491a&scoped=true&"
import script from "./factory_order_detail.vue?vue&type=script&lang=js&"
export * from "./factory_order_detail.vue?vue&type=script&lang=js&"
import style0 from "./factory_order_detail.vue?vue&type=style&index=0&id=5dcf491a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcf491a",
  null
  
)

export default component.exports